import { Link } from "react-router-dom";
const getYear = () => new Date().getFullYear();
export default function Footer() {
    return(
        <footer className="tf-landing-footer">
            <div className="container-full">
                <div className="content text-center flat-spacing-12">
                    <div className="bg-img">
                        <img loading="lazy" width="1384" height="640" src="images/explore.jpg" alt="Image"/>
                    </div>
                    <h2 className="title text-80-84 text-white letter-space--3 wow fadeZoom">
                        Transforming Aerial <br/>Intelligence
                    </h2>
                    <p className="desc text-white text-body-2 wow fadeInUp">
                        Revolutionizing the way you see the whole world with smart, robust, and trustworthy drone systems.
                    </p>
                    <div className="wow fadeInUp">
                        <a href="#" className="tf-btn-2 has-icon has-ic-large" data-bs-toggle="modal" data-bs-target="#reqDemo">
                            <div className="wrap-text text-body-2 fw-medium text-white">
                                <div className="ic-wrap">
                                    <i className="fa-solid fa-arrow-right arrow-right"></i>
                                </div>
                                <span className="text text-linear">
                                    Request Demo
                                </span>
                            </div>
                        </a>
                    </div>
                    <div className="mt-4 mb-md-0">
                        © {getYear()} Infinitive Host. All rights reserved &nbsp;
                        <Link to="https://www.infinitivehost.com/" target="_blank" rel="noopener noreferrer" className="footer-link fw-bolder" >
                            InfinitiveHost
                        </Link>
                        </div>
                </div>
            </div>
        </footer>
    )
}